import { render, staticRenderFns } from "./ParametersAside.vue?vue&type=template&id=dc696cbc&scoped=true&"
import script from "./ParametersAside.vue?vue&type=script&lang=js&"
export * from "./ParametersAside.vue?vue&type=script&lang=js&"
import style0 from "./ParametersAside.vue?vue&type=style&index=0&id=dc696cbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc696cbc",
  null
  
)

export default component.exports